export class Stamplayoutfile {
  id: number;
  name: string;
  length: string;
  base64Data: string;
  excelName: string;
  excelLength: string;
  excelBase64Data: string;
  active: number;
}
